module.exports = __webpack_public_path__ + "static/media/beach2382.fff4acff.jpg";